var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15002 6.65469H14.85M13.55 6.65469V15.7547C13.55 16.0995 13.4131 16.4301 13.1693 16.6739C12.9255 16.9177 12.5948 17.0547 12.25 17.0547H5.75002C5.40524 17.0547 5.07458 16.9177 4.83079 16.6739C4.58699 16.4301 4.45002 16.0995 4.45002 15.7547V6.65469M6.40002 6.65469V5.35469C6.40002 5.00991 6.53699 4.67925 6.78079 4.43545C7.02458 4.19165 7.35524 4.05469 7.70002 4.05469H10.3C10.6448 4.05469 10.9755 4.19165 11.2193 4.43545C11.4631 4.67925 11.6 5.00991 11.6 5.35469V6.65469M7.70002 9.90469V13.8047M10.3 9.90469V13.8047",
    stroke: "#101820",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.06c43d87cb9d9c1688bd0f256615096b.svg";
export { ForwardRef as ReactComponent };